import { updateConditionChildPositionAction as updateConditionChildPositionOperation } from 'editor/src/store/design/slice';

export default updateConditionChildPositionOperation;
